module.exports = __webpack_public_path__ + "img/74.91d1b7d.png";